import { createFileRoute } from '@tanstack/react-router';

import { RecordingPage, recordingBeforeLoad, recordingSearchSchema } from '@/pages/recording';

export const Route = createFileRoute('/recording')({
    validateSearch: recordingSearchSchema,
    beforeLoad: recordingBeforeLoad,
    component: RecordingPage,
});
